import { LumiDB, type TilesetTreeNode } from "@lumidb/lumidb";
import * as THREE from "three";
import { CustomPointMaterial } from "./point-material";

/// Represents an area selection made on the map. The aabb field is a bounding box in the form [minX, minY, maxX, maxY]
// (same ordering as an Extent in OpenLayers).
export type QueryShape = { polygon: number[][][] };

// TODO: is this class even needed? Seems like it just wraps stuff from the API response. Perhaps we could
// just use the api response object directly.
export class PointChunk {
    points: THREE.Points<THREE.BufferGeometry, CustomPointMaterial>;
    pointCount: number;
    byteSize: number;
    seenIndices: Set<number>;
    seenClassifications: Set<number>;
    intensityRange: [number, number];
    offset: THREE.Vector3;
    queryCenter: THREE.Vector3;
    queryArea: number;
    bounds: { min: number[]; max: number[] };

    constructor(
        points: THREE.Points<THREE.BufferGeometry, CustomPointMaterial>,
        pointCount: number,
        byteSize: number,
        seenIndices: Set<number>,
        classifications: Set<number>,
        intensityRange: [number, number],
        offset: THREE.Vector3,
        queryCenter: THREE.Vector3,
        queryArea: number,
        bounds: { min: number[]; max: number[] },
    ) {
        this.points = points;
        this.pointCount = pointCount;
        this.byteSize = byteSize;
        this.seenIndices = seenIndices;
        this.offset = offset;
        this.queryCenter = queryCenter;
        this.queryArea = queryArea;
        this.intensityRange = intensityRange;
        this.seenClassifications = classifications;
        this.bounds = bounds;
    }

    static async loadTile(
        lumidb: LumiDB,
        tableName: string,
        node: TilesetTreeNode["content"],
        material: CustomPointMaterial,
        abortSignal?: AbortSignal,
    ) {
        const resp = await lumidb.get3DTile({
            tableName,
            content: node,
            output_type: "threejs",
            abortSignal,
        });

        const points = new THREE.Points(resp.pointGeometry as unknown as THREE.BufferGeometry, material);

        return new PointChunk(
            points,
            resp.pointCount,
            resp.bytes,
            new Set(resp.sourceFileIds),
            new Set(resp.classifications),
            resp.intensityRange,
            new THREE.Vector3().fromArray(resp.offset),
            new THREE.Vector3().fromArray(resp.queryCenter),
            resp.queryArea,
            resp.bounds,
        );
    }
}
